<template>
	<div>
		<div class="mobile-input">
			<my-input
			 :tipText="mobileTip"
			 :text="mobile"
			 :isError="mobileIsError"
			 :maxLength="mobileMaxLength"
			 @tipClick="mobileClick"
			 @blurEvent="checkMobile"
			 @on-change="mobileChange"
			 :inputType="inputType"
			></my-input>
			<span
			 class="checkCode-btn"
			 :class="btnState"
			 v-show="mobileRight && !mobileAuthState"
			 @click="getCheckCode"
			>{{getCheckCodeText}}</span>
			<i
			 class="icon-mobile"
			 v-show="mobileAuthState"
			></i>
		</div>
		<div
		 class="checkCode-input"
		 v-show="showCheckCode"
		>
			<my-input
			 inputID="checkCodeInput"
			 :tipText="checkCodeTip"
			 :text="checkCode"
			 :isError="checkCodeIsError"
			 :maxLength="checkCodeMaxLength"
			 @tipClick="checkCodeClick"
			 @blurEvent="verifyCheckCode"
			 :isFocusing="focusCheckCode"
			 :inputType="inputType"
			></my-input>
			<i
			 class="checkCode-right"
			 v-show="checkCodeState"
			></i>
		</div>
	</div>
</template>
<script>
import * as types from "../../../store/mutation-types";
import config from "../../../util/config";
import myInput from "../../common/myInput";
import { mapGetters } from "vuex";
export default {
	components: {
		myInput
	},
	data() {
		return {
			inputType: "tel", // input框类型
			mobileTip: "输入手机号", // 手机号框
			mobile: "",
			mobileIsError: false,
			mobileMaxLength: 11,

			checkCodeTip: "请输入6位验证码", // 验证码框
			checkCode: "",
			checkCodeIsError: false,
			checkCodeMaxLength: 6,
			focusCheckCode: false, // 验证码获取焦点

			mobileRight: false, // 手机号是否正确
			getCheckCodeText: "获取验证码",
			timer: undefined,
			btnState: "",
			showCheckCode: false, // 是否展示验证码框
			checkCodeState: false, // 验证码状态
			mobileAuthState: false, // 手机号认证状态
			isIOS: navigator.userAgent.match(/iphone/i)
		};
	},
	computed: {
		...mapGetters([
			"hasAuthedMobile",
			"authMobile",
			"hasAuthed",
			"captcha",
			"getCaptchaState",
			"getCaptchaErrorInfo",
			"checkCodeRight",
			"pagetypeLog"
		])
	},
	watch: {
		authMobile(val) {
			this.setMobile(val);
		},
		hasAuthed(val) {
			this.setAuthed(val);
		},
		checkCodeRight(val) {
			this.checkCodeState = val;
		},
		checkCodeState(val) {
			// 验证码正确，收起验证码框，手机号设为已认证状态
			if (val) {
				this.checkCodeIsError = false;
				this.checkCodeTip = "验证码";
				this.showCheckCode = false;
				this.mobileAuthState = true;
				this.mobileIsError = false;
				this.mobileTip = "手机号";
			} else {
				this.checkCodeIsError = true;
				this.checkCodeTip = "验证码输入错误";
			}
		}
	},
	created() {
		this.setMobile(this.authMobile);
		this.setAuthed(this.hasAuthed);
	},
	methods: {
		// 手机号初始化
		setMobile(val) {
			if (val && this.mobile === "") {
				this.mobile = val;
				if (!this.hasAuthed) {
					this.mobileRight = true;
					this.mobileIsError = true;
					this.mobileTip = "手机号未验证";
				}
			}
		},
		setAuthed(val) {
			this.mobileAuthState = val; // 认证状态存储在缓存中
			if (val) {
				this.mobileIsError = false;
				this.mobileTip = "手机号";
				this.showCheckCode = false; // 验证码框隐藏
			} else {
				this.mobileIsError = true;
				this.mobileTip = "手机号未验证";
			}
		},
		// 手机号项点击
		mobileClick(value) {
			if (value === "") {
				this.mobileIsError = false;
				this.mobileTip = "请输入11位手机号码";
			}
			window.clickLog &&
				window.clickLog("from=jl_phonenumclk_login" + this.pagetypeLog);
		},

		// 手机号由正确状态改为错误状态时，隐藏获取验证码按钮
		mobileChange(mobile) {
			if (mobile.length < 11) {
				this.mobileRight = false;
				this.mobileAuthState = false;
				// 修改认证状态为false
				this.$store.commit(types.CHANGE_HASAUTHED, {
					auth: false
				});

				// 清除计时器
				clearTimeout(this.timer);
				this.getCheckCodeText = "获取验证码";
				this.btnState = "";
			}
		},

		// 检查手机号
		async checkMobile(value) {
			// 检查前默认将手机号填写状态置为false
			this.$store.commit(types.CHECK_BASICINFO, {
				key: "mobile",
				value: value,
				state: false
			});
			if (value === "") {
				this.mobileAuthState = false;
				this.mobileIsError = true;
				this.mobileRight = false;
				this.mobileTip = "输入手机号";
			} else if (!config.mobileReg.test(value)) {
				this.mobileAuthState = false;
				this.mobileIsError = true;
				this.mobileRight = false;
				this.mobileTip = "手机号码格式不对";
			} else {
				// 如果手机号为后置登录使用的手机号则直接为已认证状态
				if (value === this.hasAuthedMobile) {
					this.mobileAuthState = true;
					// 修改认证状态为true
					this.$store.commit(types.CHANGE_HASAUTHED, {
						auth: true
					});
				} else {
					// 如果手机号输入达11位且正确，则进行检查认证
					this.mobileIsError = false;
					this.mobileTip = "手机号";
					this.mobile = value;
					await this.$store.dispatch("checkMobileAuth", value);
					this.mobileRight = true;
				}
			}
		},

		// 验证码点击
		checkCodeClick(value) {
			if (value === "") {
				this.checkCodeIsError = false;
				this.checkCodeTip = "请输入6位验证码";
			}
		},

		// 校验验证码
		async verifyCheckCode(value) {
			// 检查前默认将验证码填写状态置为false
			this.$store.commit(types.CHECK_BASICINFO, {
				key: "keyCode",
				value: value,
				state: false
			});
			if (value === "") {
				this.checkCodeIsError = true;
				this.checkCodeTip = "输入验证码";
			} else if (value.length < 6) {
				this.checkCodeState = false;
				this.checkCodeIsError = true;
				this.checkCodeTip = "请输入6位验证码";
			} else {
				// 由于需要对请求结果进行判断，所以使用await
				await this.$store.dispatch("verifyCheckCode", {
					mobile: this.mobile,
					code: value
				});

				if (!this.checkCodeRight) {
					this.checkCodeIsError = true;
					this.checkCodeTip = "验证码输入错误";
				}
			}
		},

		// 获取手机验证码点击事件
		async getCheckCode() {
			if (this.btnState === "") {
				await this.$store.dispatch("getCheckCode", this.mobile);
				// 发送成功
				if (this.getCaptchaState) {
					this.btnState = "disabled";
					this.countDown();
					this.checkCodeState = false;
					this.showCheckCode = true;

					// 非ios时将焦点置于验证码框，ios不进行焦点转移
					if (this.isIOS) {
						this.checkCodeTip = "输入验证码";
					} else {
						this.focusCheckCode = true;
					}
				} else {
					// 提示错误信息
					this.mobileTip = this.getCaptchaErrorInfo;
					this.mobileIsError = true;
				}
			}
		},

		// 按钮倒计时
		countDown(wait = 60) {
			if (wait === 0) {
				this.getCheckCodeText = "重新获取";
				this.btnState = "";
			} else {
				this.getCheckCodeText = "已发送" + wait + "s";
				wait--;
				this.timer = setTimeout(() => {
					this.countDown(wait);
				}, 1000);
			}
		},

		// 点击保存检查为空
		checkNull() {
			this.checkMobile("");
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";

.mobile-input,
.checkCode-input {
	width: 100%;
	position: relative;
}

.input-tip {
	margin-top: 0;
}

.checkCode-btn {
	display: inline-block;
	position: absolute;
	top: px2rem(56px);
	right: px2rem(64px);
	height: px2rem(60px);
	line-height: px2rem(58px);
	padding: 0 px2rem(20px);
	border: 1px solid $orange;
	border-radius: px2rem(124px);
	font-size: px2rem(26px);
	color: $orange;
}

.icon-mobile {
	background: url(../../../assets/img/phone_number_correct.png) no-repeat;
	background-size: contain;
	border-radius: px2rem(30px);
	position: absolute;
	top: px2rem(70px);
	right: px2rem(120px);
	display: inline-block;
	width: px2rem(120px);
	height: px2rem(30px);
	line-height: px2rem(30px);
}

.checkCode-right {
	background: url(../../../assets/img/correct_right.png);
	background-size: contain;
	border-radius: px2rem(30px);
	position: absolute;
	top: px2rem(70px);
	right: px2rem(232px);
	display: inline-block;
	width: px2rem(30px);
	height: px2rem(30px);
	line-height: px2rem(30px);
}

.disabled {
	border: 1px solid #e3e3e4;
	color: #cccccc;
	width: px2rem(170px);
}
</style>



// WEBPACK FOOTER //
// mobile.vue?b614adf8